import React, { useEffect, useState } from "react";
import useDataSession from "../../customeHooks/useDataSession";
import useCoreAgora from "../../../../general/customHooks/coreAgora";

import { classNames } from "../../../../general/functions/propsComponent";
import VideoPlayer from "../../../../general/components/VideoUser/VideoPlayer";
import { checkVoulumeLevel } from "../../../../general/functions/agoraCustomeFunctions";
import { StartRecording } from "../../actions/recordingActions";
import { useDispatch, useSelector } from "react-redux";
import GuideAssessor from "../molekuls/GuideAssessor";
import AssessorControls from "../molekuls/AssessorControls";
import HeaderOnSesssion from "../molekuls/HeaderOnSesssion";
import AnswerListFromAssessee from "../molekuls/AnswerListFromAssessee";
import useRoomAgora from "../../customeHooks/useRoomAgora";
export default function RolePlayAssessorView() {
  const { selfUid, session, listUser, dataSession } = useDataSession();
  console.log("useDataSession", selfUid, session, dataSession, listUser);
  const [listUserData, setListUserData] = useState([]);
  const [showGuide, setShowGuide] = useState(false);
  const [showListAnswer, setShowListAnswer] = useState(false);

  const {
    usersJoin,
    usersVolume,
    isConnect,
    isSelfTracksReady,
    selfTracks,
    isMuteTrackSelf,
    isShareScreen,
    setJoin,
    setMuteSelfTracks,
    setSchareScreen,
    setShareScreenUid,
    errorInfo,
    stats,
  } = useCoreAgora({
    uid: parseInt(selfUid),
    channelName: session,
  });
  const { handleLeaveAlone } = useRoomAgora({ setJoin });

  useEffect(() => {
    setJoin(true);
  }, []);

  useEffect(() => {
    console.log("aasessee testing listUser", listUser);
    let tmp = listUser?.map((x) => {
      let dTmp = usersJoin.find((y) => y.uid == x.uId);

      if (dTmp != undefined) {
        x.agora = dTmp;
      } else {
        x.agora = null;
      }
      return x;
    });
    let uidShareScreen = tmp?.find(
      (y) => y?.agora == null && y.type == "SHARESCREEN"
    );
    setShareScreenUid(
      uidShareScreen?.uId != undefined ? uidShareScreen?.uId : null
    );
    setListUserData(tmp);
  }, [usersJoin, listUser]);

  const dispatch = useDispatch();
  const store = useSelector((state) => state.smvm_recording);
  useEffect(() => {
    // console.log("Start Record Effect");
    if (isConnect == true && recordingIsAvailable == false) {
      // console.log("Send Start Record Effect");
      dispatch(StartRecording(dataSession?.sessionInfo?.projectId));
    }
    if (isConnect) {
      // setMuteSelfTracks("audio", false);
      setMuteSelfTracks("video", false);
    }
  }, [isConnect]);

  let screenShareAvailable =
    listUserData?.find((x) => x.type == "SHARESCREEN")?.agora?.agoraDetail !=
    null;
  let recordingIsAvailable =
    listUserData?.find((x) => x.type == "RECORDING")?.agora != null;
  let listUserView = listUserData
    ?.sort((a, b) => {
      let na = 0;
      let nb = 0;
      if (a?.isMuteTrackSelf?.video) {
        na += 1;
      }
      if (a?.isMuteTrackSelf?.audio) {
        na += 2;
      }
      if (b?.isMuteTrackSelf?.video) {
        nb += 1;
      }
      if (b?.isMuteTrackSelf?.audio) {
        nb += 2;
      }
      if (na > nb) {
        return 1;
      }
      if (na < nb) {
        return -1;
      }
    })
    ?.filter(
      (x) =>
        x.type != "SHARESCREEN" && x.type != "RECORDING" && x?.agora != null
    );
  let positionVideoList =
    listUserData?.filter((x) => x.type != "RECORDING" && x?.agora != null)
      .length >= 4;
  return (
    <>
      <div
        className=" h-full flex w-full overflow-hidden "
        style={{ height: "92vh", maxWidth: "100vw", minHeight: "720px" }}
      >
        <div className={classNames("w-full h-full  mx-auto  ")}>
          <HeaderOnSesssion
            title={"Role Play | " + dataSession.sessionInfo?.sessionTitle}
            sub={
              "Assessor View, " +
              (recordingIsAvailable ? "Record" : "Not Record")
            }
          />
          {screenShareAvailable && (
            <div
              className=" flex justify-center items-center pt-4  w-full"
              style={{
                height: screenShareAvailable ? "65%" : "0%",
              }}
            >
              <div
                className="aspect-video  flex  items-center justify-center "
                style={{ width: "100%", maxHeight: "100%" }}
              >
                <VideoShareScreen
                  shareScreen={listUserData.find(
                    (x) => x.type == "SHARESCREEN"
                  )}
                  usersVolume={usersVolume}
                />
              </div>
            </div>
          )}
          {/* <p className="text-white">asdsd {isConnect.toString()}</p> */}
          <div
            className={classNames(
              " flex gap-2 mt-2  overflow-auto p-2 ",
              positionVideoList ? "" : "justify-center"
            )}
            style={{
              height: screenShareAvailable ? "50%" : "80vh",
              width: "100%",
            }}
          >
            {isConnect && (
              <VideoList
                users={listUserView}
                usersVolume={usersVolume}
                isShareScreen={screenShareAvailable}
                userSelf={{ ...dataSession?.user, isMuteTrackSelf }}
                tracks={selfTracks}
              />
            )}
          </div>
        </div>
        <div
          className={classNames(
            "sticky  top-0 max-w-sm  right-0  min-h-screen   bg-gray-100 transition-all duration-100  ease-out",
            showListAnswer
              ? " -translate-x-0 w-full "
              : "translate-x-96 overflow-hidden w-0"
          )}
        >
          <div className="   min-h-[95vh] overflow-auto">
            <AnswerListFromAssessee />
          </div>
        </div>
        <div
          className={classNames(
            "sticky  top-0 max-w-sm  right-0  min-h-screen   bg-gray-100 transition-all duration-100  ease-out",
            showGuide
              ? " -translate-x-0 w-full "
              : "translate-x-96 overflow-hidden w-0"
          )}
        >
          {/* <div className=" px-2 pb-32 bg-red-200 overflow-auto h-full "> */}
          <div className="   min-h-[95vh] overflow-auto">
            <GuideAssessor />
            {/* <div className="flex">
              <p>Guide</p>
              <p>Aspect</p>
              <p>Private Note</p>
            </div> */}
            {/* Main Content */}
            <div></div>
            {/* End Main Content */}
          </div>
        </div>
      </div>

      <div className="h-14"></div>
      {isSelfTracksReady && selfTracks && (
        <div className="py-2 px-2 fixed bottom-0 w-full bg-black">
          <AssessorControls
            tracks={selfTracks}
            tracksState={isMuteTrackSelf}
            isShareScreen={isShareScreen}
            isOtherShareScreen={
              screenShareAvailable == true && isShareScreen == false
              // true
            }
            errorInfo={errorInfo}
            setJoin={(v) => {
              setJoin(v);
              handleLeaveAlone(!v);
            }}
            setMute={(v) => {
              setMuteSelfTracks(v?.type, v?.status);
            }}
            setShareScreen={() => {
              setSchareScreen(!isShareScreen);
            }}
            channelName={session}
            setShowGuide={() => {
              setShowGuide(!showGuide);
            }}
            setShowListAnswer={() => {
              setShowListAnswer(!showListAnswer);
            }}
          />
        </div>
      )}
    </>
  );
}

const VideoShareScreen = (props) => {
  const { shareScreen } = props;
  let videoMain = shareScreen?.agora?.agoraDetail != null ? shareScreen : null;
  console.log("videoMain", videoMain);
  return (
    <>
      {videoMain != null && (
        <div
          className="relative h-full p-0  border border-secondary-300 aspect-video "
          style={{}}
        >
          <VideoPlayer
            videoTrack={videoMain?.agora?.agoraDetail.videoTrack}
            isVideoMute={!videoMain?.agora?.video}
            isMicMute={!videoMain?.agora?.audio}
            title={videoMain?.name}
            uid={videoMain?.uId}
            tagLable={videoMain?.type == "ASSESSOR" ? videoMain?.type : null}
            shareScreen={shareScreen?.agora?.agoraDetail != null ? true : false}
            isSpeak={false}
          />
        </div>
      )}
    </>
  );
};

const getGridCols = (c, isShareScreen) => {
  if (isShareScreen == true) {
    return "grid-cols-6";
  } else {
    if (c <= 2) {
      return "grid-cols-2";
    } else if (c <= 9) {
      return "grid-cols-3";
    } else if (c <= 12) {
      return "grid-cols-4";
    } else if (c <= 20) {
      return "grid-cols-5";
    } else {
      return "grid-cols-6";
    }
  }
};

const VideoList = (props) => {
  const { users, tracks, userSelf, usersVolume, isShareScreen } = props;
  let userJoinCount = users.length;

  return (
    <>
      <div
        className={classNames(
          "grid bg-black w-full overflow-auto",
          isShareScreen ? "max-h-[20vh]" : "max-h-[80vh]",
          getGridCols(userJoinCount, isShareScreen)
        )}
        style={{}}
      >
        <div className="aspect-video">
          <VideoPlayer
            videoTrack={tracks[1]}
            isVideoMute={!userSelf.isMuteTrackSelf?.video}
            isMicMute={!userSelf.isMuteTrackSelf?.audio}
            title={userSelf?.name}
            uid={userSelf?.uId}
            tagLable={userSelf?.type == "ASSESSOR" ? userSelf?.type : null}
            isSpeak={checkVoulumeLevel(usersVolume, userSelf?.uId).status}
          />
        </div>

        {users?.map((x, i) => {
          // sharescrin off withoud 1, on with 1
          return (
            <>
              <div className="aspect-video">
                <VideoPlayer
                  videoTrack={x.agora?.agoraDetail?.videoTrack}
                  isVideoMute={!x.agora?.video}
                  isMicMute={!x.agora?.audio}
                  title={x?.name}
                  uid={x?.uId}
                  tagLable={x?.type == "ASSESSOR" ? x?.type : null}
                  isSpeak={checkVoulumeLevel(usersVolume, x?.uId).status}
                />
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};
